"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import BrokeredCarrierTermsStore from "../stores/brokered_carrier_terms_store";
const store = BrokeredCarrierTermsStore;
class BrokeredCarrierTermsService {
  constructor() {
    __publicField(this, "all", () => {
      if (store.fetched) {
        return Promise.resolve(store.items);
      } else {
        return this.fetchAll();
      }
    });
    __publicField(this, "forClient", (tms_carrier) => this.all().then((terms) => {
      if (tms_carrier.program_external_id) {
        return terms.filter(
          (term) => term.program_external_id === tms_carrier.program_external_id
        );
      } else {
        return terms;
      }
    }));
    __publicField(this, "fetchAll", () => {
      return Promise.resolve().then(() => {
        store.fetched = true;
        return $.get("/api/brokered_carrier_terms/").then(function(data) {
          store.addOrUpdateAll(data.brokered_carrier_terms);
          return store.items;
        });
      });
    });
  }
}
const brokeredCarrierTermsService = new BrokeredCarrierTermsService();
export default brokeredCarrierTermsService;
